var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"production-insurance","route":"/reports/billing-production-insurance","file-name":"producao-por-convenio.xlsx","period-label":"Período do atendimento","columns":_vm.columns,"default-days":30}})
}
var staticRenderFns = []

export { render, staticRenderFns }